import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import Reveal from "./Reveal";

const FAQS = [
    {
        q: "Do you only work with elder law firms?",
        a: "We specialize in elder law and estate planning. That focus gives us a deep understanding of the search behavior, competition, and client acquisition challenges of these practices, and we serve firms across the United States.",
    },
    {
        q: "Do you manage Google Ads campaigns?",
        a: "Yes. Scalehaus can manage campaign strategy, setup, keyword research, ad creation, conversion tracking, optimization, and ongoing performance analysis.",
    },
    {
        q: "Do you also manage Meta Ads?",
        a: "Yes. Meta Ads can be used for awareness, lead generation, retargeting, and supporting the firm's broader paid acquisition strategy.",
    },
    {
        q: "Does my law firm need an existing Google Ads account?",
        a: "No. We can help establish the necessary advertising and tracking infrastructure.",
    },
    {
        q: "How quickly can campaigns launch?",
        a: "Campaign launch timing depends on account access, website readiness, tracking setup, advertising approvals, and campaign requirements.",
    },
    {
        q: "Do you guarantee leads?",
        a: "No. We don't believe responsible marketing agencies should guarantee a specific number of leads. We build, measure, test, and optimize campaigns based on actual performance.",
    },
    {
        q: "How much should a law firm spend on advertising?",
        a: "There is no universal number. Budget should depend on search demand, competition, geography, practice area economics, and the firm's ability to convert consultations into clients.",
    },
];

export const FAQ = () => (
    <section
        id="faq"
        className="py-24 md:py-32 lg:py-40 bg-ink-800/40 border-y border-white/5"
    >
        <div className="shell max-w-4xl">
            <Reveal className="text-center">
                <p className="eyebrow mb-5">FAQ</p>
                <h2 className="font-serif font-medium text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white">
                    Frequently Asked Questions
                </h2>
            </Reveal>
            <Reveal delay={0.15}>
                <Accordion
                    type="single"
                    collapsible
                    className="mt-14 border-t border-white/10"
                >
                    {FAQS.map((f, i) => (
                        <AccordionItem
                            key={i}
                            value={`faq-item-${i}`}
                            data-testid={`faq-item-${i}`}
                            className="border-b border-white/10"
                        >
                            <AccordionTrigger className="py-6 text-left font-serif text-lg md:text-xl text-white hover:text-brass-400 hover:no-underline transition-colors duration-300 [&>svg]:text-brass-500">
                                {f.q}
                            </AccordionTrigger>
                            <AccordionContent className="text-sm md:text-base leading-relaxed text-zinc-400 pb-6">
                                {f.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </Reveal>
        </div>
    </section>
);

export default FAQ;
